var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "form-page-detail" } },
    [
      _c(
        "div",
        {
          staticClass: "form-page-detail--header",
          class: { "form-page-detail--header-long": !_vm.is_sidebar_minimized }
        },
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "8" } }, [
                _c("div", { staticClass: "name-data--header" }, [
                  _vm._v(_vm._s(_vm.dataset_data.name))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "id-data--header" }, [
                  _vm._v(_vm._s(_vm.dataset_data.id))
                ])
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "4" } }, [
                _c("i", {
                  staticClass:
                    "fa fa-ellipsis-v fa-lg cursor-pointer pull-right m__l--10 m__t--10",
                  attrs: { id: "configPopover" }
                })
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass: "form-page-detail--header_tab",
              attrs: { id: "form-header-tab" }
            },
            _vm._l(_vm.tabs, function(tab) {
              return _c(
                "b-col",
                {
                  key: tab.id,
                  staticClass: "studio-page-tab",
                  class: {
                    "studio-page-tab-active": _vm.tabSelected === tab.id
                  },
                  on: {
                    click: function($event) {
                      _vm.selectTab(tab.id)
                    }
                  }
                },
                [
                  _c("h4", [_vm._v(_vm._s(tab.label))]),
                  _vm._v(" "),
                  _vm.tabSelected === tab.id
                    ? _c("div", { staticClass: "underline-data" })
                    : _vm._e()
                ]
              )
            })
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-page-detail--body" },
        [
          _vm.tabSelected === "general" ? _c("j-dataset-general") : _vm._e(),
          _vm._v(" "),
          _vm.tabSelected === "column" ? _c("j-dataset-column") : _vm._e(),
          _vm._v(" "),
          _vm.tabSelected === "data" ? _c("j-dataset-data") : _vm._e(),
          _vm._v(" "),
          _vm.tabSelected === "query" ? _c("j-dataset-query") : _vm._e(),
          _vm._v(" "),
          _vm.tabSelected === "indexes" ? _c("j-dataset-indexes") : _vm._e(),
          _vm._v(" "),
          _vm.tabSelected === "exp-manager"
            ? _c("j-dataset-exp-manager")
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "configPopoverRef",
          attrs: {
            show: _vm.configPopoverShow,
            target: "configPopover",
            placement: "left"
          },
          on: {
            "update:show": function($event) {
              _vm.configPopoverShow = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "add-automation", on: { click: _vm.deleteDataset } },
            [_vm._v("Delete Dataset")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "add-automation",
              on: { click: _vm.truncateDataset }
            },
            [_vm._v("Truncate Data")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appCodeFormDataModal",
          staticClass: "mod-form modal-code-form-data",
          attrs: { centered: "" }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("VIEW CODE")
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "btn-delete", on: { click: _vm.copyCode } },
            [
              _c("i", {
                staticClass: "fa fa-files-o font-weight-bold cursor-pointer"
              }),
              _vm._v(" Copy\n    ")
            ]
          ),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "scroll-script" },
            [
              _c("prism-editor", {
                staticClass: "my-editor m__t--10",
                class: { "dark-mode": _vm.darkMode },
                attrs: { highlight: _vm.highlighter, "line-numbers": true },
                model: {
                  value: _vm.jsonData,
                  callback: function($$v) {
                    _vm.jsonData = $$v
                  },
                  expression: "jsonData"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "6" } }, [
                _c("div", { staticStyle: { opacity: "0" } }, [
                  _c("textarea", {
                    attrs: { id: "view-code" },
                    domProps: { value: _vm.viewCode }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "6" } }, [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: { click: _vm.closeCodeForm }
                      },
                      [_vm._v("\n            Close\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65219b7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65219b7e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/joanadb/dataset/jDatasetPageDetail.vue
// module id = null
// module chunks = 